import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCompanyList } from '../actions/companyActions'

const useFetchingCompany = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCompanyList())
  }, [dispatch])
}

export default useFetchingCompany
